// Effective Estimator quantity for a row: the qty-box override when the user has entered one,
// otherwise the source (contract/itemized) quantity.
export const getEffectiveQty = (qtyEdits, key, sourceQty) => {
  const edited = qtyEdits ? qtyEdits[key] : undefined;
  if (edited !== undefined && edited !== '') return parseFloat(edited) || 0;
  return parseFloat(sourceQty) || 0;
};

// Save-payload fragment for a line item's quantity. Include `quantity` for every row that
// currently carries an override — a value typed into the qty box this session, or a previously
// saved override reloaded from estimateDiscount.lineItems — so the override is re-sent on every
// Save. The backend resets a line's qty whenever the key is absent, so re-sending is what stops a
// prior override from being wiped when the user saves after editing a *different* item. Rows with
// no override omit the key and stay at the source quantity.
export const buildQtyPayloadField = (qtyEdits, key, sourceQty) => {
  const raw = qtyEdits ? qtyEdits[key] : undefined;
  if (raw === undefined || raw === '') return {};
  const effective = getEffectiveQty(qtyEdits, key, sourceQty);
  return effective > 0 ? { quantity: effective } : {};
};
